const MOBILE_MENU_TYPES = {
	default:       'list',
	list:          'list',
	grid:          'grid',
	video:         'video',
	videoSettings: 'videoSettings',
	eventTag:      'eventTag',
	eventTagBulk:  'eventTagBulk',
};

export default MOBILE_MENU_TYPES;
